import React, { PropTypes } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';
import cn from 'classnames';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import JacketCoverContainer from '../../../containers/JacketCoverContainer';
import WorkflowContainer from '../../../containers/WorkflowContainer';

import './BibListItem.scss';

export class BibListItem extends BcReactComponent {

  getBib() {
    return this.props.bib ?
      this.props.bib :
      Immutable.fromJS({
        title: this.props.intl.formatMessage({ id: 'not_available' }),
        id: ''
      });
  }

  render () {
    const { className, renderInfo, renderFooterInfo, renderBibBrief, workflowId } = this.props;
    const bib = this.getBib();
    const renderedInfo = renderInfo();
    const renderedFooterInfo = renderFooterInfo();

    return (
      <WorkflowContainer id={workflowId || bib.get('metadataId')}>
        {workflowComponent =>
          workflowComponent || (
            <div className={cn('cp-bib-list-item', className)}>
              <div className="item-row item-header">
                <div className="item-column brief-info">
                  <div className="jacket-cover-container">
                    <JacketCoverContainer src={bib.get('jacket')} format={bib.get('format')} alt="" />
                  </div>
                  {renderBibBrief()}
                </div>
                {renderedInfo ? <div className="item-column additional-info">{renderedInfo}</div> : null}
              </div>
              {renderedFooterInfo ? <div className="item-row item-footer">{renderedFooterInfo}</div> : null}
            </div>
          )
        }
      </WorkflowContainer>
    );
  }
}

BibListItem.propTypes = {
  renderInfo: PropTypes.func, // The side information
  renderFooterInfo: PropTypes.func,
  className: PropTypes.string,
  bib: ImmutablePropTypes.map,
  workflowId: PropTypes.string,
  renderBibBrief: PropTypes.func,
  intl: intlShape
};

BibListItem.defaultProps = {
  renderInfo: () => null,
  renderFooterInfo: () => null,
  renderBibBrief: () => null
};

export default injectIntl(BibListItem);



// WEBPACK FOOTER //
// ./app/components/shared/BibListItem/BibListItem.jsx